import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SfxInput from "src/components/input/SfxInput.vue"
import SfxIssueBase from "src/components/issue/SfxIssueBase.vue"
import { computed, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxIssueCorrectiveAction',
  props: {
  modelValue: {
    // Add ability to define required nullable props: https://github.com/vuejs/core/issues/3948
    type: null as unknown as PropType<string | null>,
    required: true,
  },

  required: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "hide"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

__expose({ forceHide, forceShow })

//endregion

//region Variables

const { t } = useI18n()
const issueBase = ref<typeof SfxIssueBase | undefined>()

const model = computed({
  get() {
    return props.modelValue
  },

  set(value) {
    return emit("update:modelValue", value)
  },
})

const title = t("sfxIssues.title_action")
const inputLabel = t("sfxIssues.label_input_action")
const promptDiscard = computed(() => Boolean(model.value))

//endregion

//region Functions

function hideMenu() {
  emit("hide", Boolean(model.value))
  model.value = null
}

function forceHide() {
  hideMenu()
  issueBase.value?.forceHide()
}

function forceShow() {
  issueBase.value?.forceShow()
}

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SfxIssueBase, {
    ref_key: "issueBase",
    ref: issueBase,
    title: _unref(title),
    required: props.required,
    "prompt-discard": promptDiscard.value,
    onHide: hideMenu
  }, {
    default: _withCtx(() => [
      _createVNode(SfxInput, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        label: _unref(inputLabel)
      }, null, 8, ["modelValue", "label"])
    ]),
    _: 1
  }, 8, ["title", "required", "prompt-discard"]))
}
}

})